(function () {
  'use strict';
  var D = window.__STORY, G = D.geo, WD = D.world;

  /* ================================================================ helpers */
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return v < a ? a : v > b ? b : v; };
  var lerp = function (a, b, t) { return a + (b - a) * t; };
  var seg = function (p, a, b) { return clamp((p - a) / (b - a), 0, 1); };
  var sm = function (t) { return t * t * (3 - 2 * t); };
  var eo3 = function (t) { return 1 - Math.pow(1 - t, 3); };
  var eio = function (t) { return t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2; };
  var eob = function (t) { var c1 = 1.15, c3 = c1 + 1; return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2); };
  var bump = function (x, w) { return Math.exp(-(x * x) / (w * w)); };
  function mulberry(a) { return function () { a |= 0; a = a + 0x6D2B79F5 | 0; var t = Math.imul(a ^ a >>> 15, 1 | a); t = t + Math.imul(t ^ t >>> 7, 61 | t) ^ t; return ((t ^ t >>> 14) >>> 0) / 4294967296; }; }
  var phone = function () { return innerWidth < 900; };
  var pad = function (n, k) { n = String(n); while (n.length < k) n = '0' + n; return n; };

  function blobURL(o) { var bin = atob(o.d), u = new Uint8Array(bin.length); for (var i = 0; i < bin.length; i++) u[i] = bin.charCodeAt(i); return URL.createObjectURL(new Blob([u], { type: o.t })); }
  var URLS = {}; Object.keys(D.img).forEach(function (k) { URLS[k] = D.img[k].u || blobURL(D.img[k]); });   // a hosted file, or embedded bytes
  function loadImg(src) { return new Promise(function (res, rej) { var im = new Image(); im.onload = function () { res(im); }; im.onerror = rej; im.src = src; }); }
  $$('img[data-img]').forEach(function (im) { im.src = URLS[im.getAttribute('data-img')]; if (im.decode) im.decode().catch(function () {}); });

  var lenis = null;
  try { if (window.Lenis) lenis = new window.Lenis({ lerp: 0.075, smoothWheel: true, wheelMultiplier: 0.9 }); } catch (e) { lenis = null; }

  var PX = G.pivot[0], W = G.W, H = G.H, P = G.pitch;
  var STAGE = $('#stage'), WORLD = $('#world'), WDARK = $('#w-dark'), WBUST = $('#w-bust'), SCN = $('#scene');
  var HTOP = $('#hero-top'), HBOT = $('#hero-bot'), HT1 = $('.ht1 .m>span'), HT2 = $('.ht2 .m>span'), HLS = $$('.hl'), LOADER = $('#loader');
  var WFRONT = $('#world-front'), DUST = $('#dust'), WSHADOW = $('#w-shadow');
  var WPLINTH = $('#world-plinth'), WDARKC = $('#world-dark'), WPL = $('#w-plinth'), PILL = $('#pill');
  var LAYERS = [WORLD, WPLINTH, WDARKC, WFRONT];
  var VIEW = { w: 1, h: 1, dpr: 1 };

  /* ================================================================ the world: the home hero's photograph, framed to the screen */
  var BB = WD.bustBox, BCX = (BB[0] + BB[2]) / 2, BCY = (BB[1] + BB[3]) / 2, BH = BB[3] - BB[1];
  // two framings of the same photograph: the hero (the piece centred, further back, seen through a window that only
  // ever shows real photograph) and the story (the piece to the right, the whole screen). Scrolling moves between them.
  var WS = { s: 1, ox: 0, oy: 0 }, WH = { s: 1, ox: 0, oy: 0 }, WIN = { x: 0, y: 0, w: 1, h: 1, r: 0 };
  var WM = { s: 1, ox: 0, oy: 0, z: 1, k: 0 };
  var TOPX = 160, HALF = Math.min(BCX, WD.W - BCX);               // wall shown above the photo's top edge; half-width either side of the bust
  function worldLayout() {
    var w = VIEW.w, h = VIEW.h, ph = phone(), s;
    if (ph) s = 0.5 * h / BH;
    else s = Math.min(Math.max(w / WD.W, h / WD.H), 0.78 * h / BH);
    WS.s = s; WS.ox = clamp((ph ? 0.5 : 0.66) * w - BCX * s, w - (WD.W + WD.R) * s, WD.L * s); WS.oy = h - WD.H * s;
    // hero: the piece centred, a little back, the plinth running off the foot of the screen; never show past the plate
    var sh = Math.max((ph ? 0.47 : 0.56) * h / BH, h / (WD.H + WD.T), w / (2 * (WD.W + WD.R - BCX)), w / (2 * (BCX + WD.L)));
    WH.s = sh; WH.ox = w / 2 - BCX * sh; WH.oy = h - WD.H * sh + h * (ph ? 0.008 : 0.035);   // room below for the camera to move
    var iw = w * (ph ? 0.62 : 0.34), ih = h * (ph ? 0.34 : 0.4);            // where the opening window starts
    WIN.x = (w - iw) / 2; WIN.y = (h - ih) / 2; WIN.w = iw; WIN.h = ih; WIN.r = ph ? 12 : 16;
    LAYERS.forEach(function (el) { el.style.width = ((WD.W + WD.L + WD.R) * s).toFixed(1) + 'px'; el.style.height = ((WD.H + WD.T + (WD.B || 0)) * s).toFixed(1) + 'px'; });
    var pb = WD.plinth;
    WPL.style.left = ((WD.L + pb[0]) * s).toFixed(1) + 'px'; WPL.style.top = ((WD.T + pb[1]) * s).toFixed(1) + 'px';
    WPL.style.width = ((pb[2] - pb[0]) * s).toFixed(1) + 'px'; WPL.style.height = ((pb[3] - pb[1]) * s).toFixed(1) + 'px';
    var c = WD.crop;
    WBUST.style.left = ((WD.L + c[0]) * s).toFixed(1) + 'px'; WBUST.style.top = ((WD.T + c[1]) * s).toFixed(1) + 'px';
    WBUST.style.width = ((c[2] - c[0]) * s).toFixed(1) + 'px'; WBUST.style.height = ((c[3] - c[1]) * s).toFixed(1) + 'px';
    ['left', 'top', 'width', 'height'].forEach(function (k) { WSHADOW.style[k] = WBUST.style[k]; });
    // the tagline on the wall: its second line runs behind the piece's head
    var fs = ph ? w * 0.15 : Math.min(w * 0.115, h * 0.2);
    STAGE.style.setProperty('--fs', fs.toFixed(1) + 'px');
    STAGE.style.setProperty('--t1', '0px');
    var head = WH.oy + BB[1] * sh, l2 = HTOP.querySelector('.ht2'), top2 = l2.offsetTop;
    STAGE.style.setProperty('--t1', (head + 0.3 * fs - 0.76 * fs - top2).toFixed(1) + 'px');
  }
  // k: 0 = hero, 1 = story; z: a slow push in about the bust; dx, dy: a little drift with the cursor
  // cam: { wx, wy } the far wall's slide, { px, py } the plinth's (and the piece's), ry/rx the piece's lean
  function worldApply(k, z, cam) {
    var s = lerp(WH.s, WS.s, k), ox = lerp(WH.ox, WS.ox, k), oy = lerp(WH.oy, WS.oy, k);
    var fx = ox + BCX * s, fy = oy + BCY * s;
    cam = cam || { wx: 0, wy: 0, px: 0, py: 0, ry: 0, rx: 0 };
    WM.k = k; WM.z = z; WM.s = s * z; WM.ox = fx * (1 - z) + ox * z + cam.wx; WM.oy = fy * (1 - z) + oy * z + cam.wy;
    var sc = (WM.s / WS.s).toFixed(5), tx = WM.ox - WD.L * WM.s, ty = WM.oy - WD.T * WM.s;
    var base = function (dx, dy) { return 'translate3d(' + (tx + dx).toFixed(2) + 'px,' + (ty + dy).toFixed(2) + 'px,0) scale(' + sc + ')'; };
    WORLD.style.transform = base(0, 0);
    var pdx = cam.px - cam.wx, pdy = cam.py - cam.wy;
    WPLINTH.style.transform = WDARKC.style.transform = base(pdx, pdy);
    if (Math.abs(cam.ry) + Math.abs(cam.rx) < 1e-3) { WFRONT.style.transform = base(pdx, pdy); return; }
    var bx = ((WD.L + BCX) * WS.s).toFixed(1), by = ((WD.T + BB[3]) * WS.s).toFixed(1);      // the piece's base, in the layer's own px
    WFRONT.style.transform = base(pdx, pdy) + ' translate(' + bx + 'px,' + by + 'px) perspective(1600px) rotateY(' + cam.ry.toFixed(3) + 'deg) rotateX(' + cam.rx.toFixed(3) + 'deg) translate(-' + bx + 'px,-' + by + 'px)';
  }
  function toScreen(x, y) { return [WM.ox + x * WM.s, WM.oy + y * WM.s]; }
  // the slices' own frame (the product page cut-out, px) sits on the hero bust: photo = origin + px * k
  function stageRect() {
    var c = toScreen(WD.x0 + W / 2 * WD.k, WD.y0 + H / 2 * WD.k), s = WD.k * WM.s;
    return { s: s, cx: c[0], cy: c[1], fx: c[0] / VIEW.w, fy: c[1] / VIEW.h, hf: H * s / VIEW.h };
  }
  var RS = null;

  /* ---------------------------------------------------------------- 3D */
  var canvas = $('#gl');
  var renderer = new THREE.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true, powerPreference: 'high-performance' });
  renderer.setClearColor(0x000000, 0);
  var GL2 = renderer.capabilities.isWebGL2;
  var scene = new THREE.Scene();
  var cam = new THREE.PerspectiveCamera(26, 1, 20, 40000);
  var N = G.sheets.length, NS = N + 2, BENCH = N, OFF = N + 1;
  var T = P * 0.999, BEV = 1.6, SPREAD = 2.0, ZC = 130;
  var SX = G.sheets.map(function (s) { return s.x; });
  var UA = [], UB = [];
  for (var i0 = 0; i0 < NS; i0++) { UA.push(new THREE.Vector4(0, 0, 0, 1)); UB.push(new THREE.Vector4(0, 0, 0, 1)); }

  function ring(a) { var v = []; for (var i = 0; i < a.length; i += 2) v.push(new THREE.Vector2(a[i] / G.scale, a[i + 1] / G.scale)); return v; }
  function areaOf(v) { var s = 0; for (var i = 0, n = v.length; i < n; i++) { var a = v[i], b = v[(i + 1) % n]; s += a.x * b.y - b.x * a.y; } return s / 2; }
  function extrude(shapes, xc, t, bev) {     // one plane: profile (z, y) extruded through x, centred on xc
    var g = new THREE.ExtrudeGeometry(shapes, { depth: t - 2 * bev, bevelEnabled: bev > 0, bevelThickness: bev, bevelSize: bev, bevelOffset: -bev, bevelSegments: 2, curveSegments: 1 });
    g.translate(0, 0, bev); g.rotateY(-Math.PI / 2); g.translate(xc + t / 2, 0, 0);
    return g.index ? g.toNonIndexed() : g;
  }
  function shapesOf(polys) {
    return polys.map(function (poly) {
      var s = new THREE.Shape(ring(poly[0]));
      for (var k = 1; k < poly.length; k++) s.holes.push(new THREE.Path(ring(poly[k])));
      return s;
    });
  }
  function merge(list) {
    var pos = [], nor = [], idx = [];
    list.forEach(function (o) {
      var p = o.g.attributes.position.array, n = o.g.attributes.normal.array;
      for (var i = 0; i < p.length; i += 3) { pos.push(p[i], p[i + 1], p[i + 2]); nor.push(n[i], n[i + 1], n[i + 2]); idx.push(o.idx); }
      o.g.dispose();
    });
    var g = new THREE.BufferGeometry();
    g.setAttribute('position', new THREE.Float32BufferAttribute(pos, 3));
    g.setAttribute('normal', new THREE.Float32BufferAttribute(nor, 3));
    g.setAttribute('aIdx', new THREE.Float32BufferAttribute(idx, 1));
    return g;
  }
  function lineGeo(list) {
    var pos = [], idx = [];
    list.forEach(function (o) {
      o.rings.forEach(function (r) {
        for (var i = 0, n = r.length; i < n; i++) { var a = r[i], b = r[(i + 1) % n]; pos.push(o.x, a.y, a.x, o.x, b.y, b.x); idx.push(o.idx, o.idx); }
      });
    });
    var g = new THREE.BufferGeometry();
    g.setAttribute('position', new THREE.Float32BufferAttribute(pos, 3));
    g.setAttribute('aIdx', new THREE.Float32BufferAttribute(idx, 1));
    return g;
  }

  // the plane cut on camera: near the middle, one big profile through the face
  var FOCUS = 0, best = -1;
  G.sheets.forEach(function (s, i) {
    if (Math.abs(s.x) > 40) return;
    var a = Math.abs(areaOf(ring(s.polys[0][0]))) - (s.polys.length - 1) * 1e5;
    if (a > best) { best = a; FOCUS = i; }
  });
  var FR = G.sheets[FOCUS].polys.map(function (pl) { return ring(pl[0]); });
  var FMAIN = FR.reduce(function (a, b) { return Math.abs(areaOf(b)) > Math.abs(areaOf(a)) ? b : a; });
  var fz0 = 1e9, fz1 = -1e9, fy0 = 1e9, fy1 = -1e9, BM = 30;
  FR.forEach(function (r) { r.forEach(function (v) { fz0 = Math.min(fz0, v.x); fz1 = Math.max(fz1, v.x); fy0 = Math.min(fy0, v.y); fy1 = Math.max(fy1, v.y); }); });

  var SHEET_VS = [
    'attribute float aIdx;',
    'uniform vec4 uA[' + NS + ']; uniform vec4 uB[' + NS + '];',
    'varying vec3 vP; varying vec3 vW; varying vec3 vN; varying vec3 vNr; varying vec4 vA; varying vec4 vB;',
    'void main() {',
    '  int i = int(aIdx + 0.5); vA = uA[i]; vB = uB[i];',
    '  vP = position; vNr = normal;',
    '  vec4 w = modelMatrix * vec4(position + vec3(vA.x, vA.y, 0.0), 1.0);',
    '  vW = w.xyz; vN = normalize(mat3(modelMatrix) * normal);',
    '  gl_Position = projectionMatrix * viewMatrix * w;',
    '}'].join('\n');
  var NOISE = [
    'float h31(vec3 p) { p = fract(p * 0.3183099 + 0.1); p *= 17.0; return fract(p.x * p.y * p.z * (p.x + p.y + p.z)); }',
    'float vn(vec3 x) { vec3 i = floor(x), f = fract(x); f = f * f * (3.0 - 2.0 * f);',
    '  return mix(mix(mix(h31(i), h31(i + vec3(1,0,0)), f.x), mix(h31(i + vec3(0,1,0)), h31(i + vec3(1,1,0)), f.x), f.y),',
    '             mix(mix(h31(i + vec3(0,0,1)), h31(i + vec3(1,0,1)), f.x), mix(h31(i + vec3(0,1,1)), h31(i + vec3(1,1,1)), f.x), f.y), f.z); }'].join('\n');
  var SHEET_FS = [
    GL2 ? '#define HAS_AO 1' : '',
    'precision highp float;',
    'uniform float uFin; uniform float uBand; uniform float uSweep; uniform float uSweepA;',
    'uniform sampler2D tTie; uniform vec3 uGeo; uniform float uShirt;',
    GL2 ? 'uniform highp sampler3D tAO; uniform vec3 uAOo; uniform vec3 uAOs;' : '',
    'varying vec3 vP; varying vec3 vW; varying vec3 vN; varying vec3 vNr; varying vec4 vA; varying vec4 vB;',
    NOISE,
    '#ifdef HAS_AO',
    'float aoAt(vec3 p, vec3 n) {',
    '  float d = texture(tAO, (p + n * 12.0 - uAOo) / uAOs).r;',
    '  float d2 = texture(tAO, (p + n * 34.0 - uAOo) / uAOs).r;',
    '  return clamp(1.0 - smoothstep(0.1, 0.65, d) * 0.45 - smoothstep(0.05, 0.5, d2) * 0.22, 0.35, 1.0);',
    '}',
    '#endif',
    'void main() {',
    '  float solid = vA.z, glow = 0.0;',
    '  if (solid < 0.999) {',
    '    float n = vn(vP * 0.09) * 0.65 + vn(vP * 0.41) * 0.35;',
    '    float th = solid * 1.16 - 0.08;',
    '    if (n > th) discard;',
    '    glow = (1.0 - smoothstep(0.0, 0.04, th - n)) * 0.85;',
    '  }',
    '  vec3 N = normalize(vN); if (!gl_FrontFacing) N = -N;',
    '  vec3 V = normalize(cameraPosition - vW);',
    '  float face = smoothstep(0.6, 0.95, abs(vNr.x));',
    '  float fib = vn(vec3(vP.x * 1.3, vP.y * 0.22, vP.z * 1.3));',
    '  vec3 raw = mix(vec3(0.49, 0.39, 0.29), vec3(0.73, 0.62, 0.48), face) * (0.87 + 0.24 * fib);',
    '  float wob = abs(vP.y - uFin) < 60.0 ? (vn(vec3(vP.x * 0.03, 1.7, vP.z * 0.03)) - 0.5) * 46.0 : 0.0;',
    '  float fy = vP.y + wob;',
    '  float fin = smoothstep(uFin + 9.0, uFin - 9.0, fy);',
    '  float band = exp(-pow((fy - uFin) / 12.0, 2.0)) * uBand;',
    '  vec2 tuv = vec2((vP.x + uGeo.x) / uGeo.y, vP.y / uGeo.z);',
    '  float tie = step(0.5, texture2D(tTie, tuv).r) * smoothstep(uShirt + 1.0, uShirt + 6.0, vP.z);',
    '  vec3 finC = mix(vec3(0.088, 0.085, 0.08) * (0.94 + 0.12 * fib), vec3(0.06, 0.058, 0.055), tie);',
    '  vec3 alb = mix(raw, finC, fin);',
    '  vec3 L1 = normalize(vec3(-0.55, 0.72, 0.62)), L2 = normalize(vec3(0.75, 0.15, 0.35));',
    '  float d1 = max(dot(N, L1), 0.0), d2 = max(dot(N, L2), 0.0), hemi = 0.5 + 0.5 * N.y;',
    '  float ao = 1.0;',
    '#ifdef HAS_AO',
    '  ao = mix(1.0, aoAt(vP, vNr), vB.w);',
    '#endif',
    '  vec3 col = alb * (0.30 + 0.22 * hemi + 0.74 * d1 + 0.24 * d2) * ao;',
    '  float spec = pow(max(dot(reflect(-L1, N), V), 0.0), 26.0);',
    '  col += spec * mix(0.035, 0.11, fin) * ao;',
    '  col += pow(1.0 - max(dot(N, V), 0.0), 4.0) * mix(0.05, 0.08, fin) * ao;',
    '  float sw = exp(-pow((vW.x - uSweep) / 80.0, 2.0)) * uSweepA * fin;',
    '  col += sw * 0.42 * max(dot(N, normalize(vec3(0.7, 0.35, 0.62))), 0.0) * ao;',
    '  col = mix(col, vec3(1.0, 0.97, 0.9), clamp(band, 0.0, 1.0) * 0.6);',
    '  vec3 ox = vec3(0.94, 0.35, 0.16);',
    '  col = mix(col, ox, clamp(glow + vB.x * (0.25 + 0.75 * (1.0 - face)), 0.0, 1.0));',
    '  gl_FragColor = vec4(col, 1.0);',
    '}'].join('\n');
  var PRE_FS = [
    'precision highp float; varying vec3 vP; varying vec4 vA;', NOISE,
    'void main() { if (vA.z < 0.999) { float n = vn(vP * 0.09) * 0.65 + vn(vP * 0.41) * 0.35; if (n > vA.z * 1.16 - 0.08) discard; } gl_FragColor = vec4(0.0); }'].join('\n');
  var LINE_VS = [
    'attribute float aIdx;',
    'uniform vec4 uA[' + NS + ']; uniform vec4 uB[' + NS + '];',
    'varying float vAl; varying float vOx;',
    'void main() { int i = int(aIdx + 0.5); vAl = uB[i].y; vOx = uB[i].z;',
    '  gl_Position = projectionMatrix * modelViewMatrix * vec4(position + vec3(uA[i].x, uA[i].y, 0.0), 1.0); }'].join('\n');
  var LINE_FS = [
    'precision highp float; uniform vec3 uLineC; varying float vAl; varying float vOx;',
    'void main() { if (vAl < 0.004) discard; gl_FragColor = vec4(mix(uLineC, vec3(0.94, 0.35, 0.16), vOx), vAl); }'].join('\n');

  var U = null, LINES = null, SPECS = null, SHADOW = null;
  var BENCHG = null, OFFG = null, KERF = null, SPARKS = null, TIP = null;
  var ready = false;

  function buildStage(aoIm, tieIm) {
    var tieTex = new THREE.Texture(tieIm); tieTex.needsUpdate = true; tieTex.minFilter = THREE.LinearFilter; tieTex.generateMipmaps = false;
    U = {
      uA: { value: UA }, uB: { value: UB },
      uFin: { value: -100 }, uBand: { value: 0 }, uSweep: { value: -2000 }, uSweepA: { value: 0 },
      uLineC: { value: new THREE.Color(0.067, 0.063, 0.055) }, tTie: { value: tieTex }, uGeo: { value: new THREE.Vector3(PX, W, H) }, uShirt: { value: G.tie.shirt }
    };
    if (GL2) {
      var A = G.ao, c = document.createElement('canvas'); c.width = aoIm.width; c.height = aoIm.height;
      var x = c.getContext('2d'); x.drawImage(aoIm, 0, 0);
      var px = x.getImageData(0, 0, c.width, c.height).data, nx = A.n[0], ny = A.n[1], nz = A.n[2], d = new Uint8Array(nx * ny * nz);
      for (var k = 0; k < nz; k++) {
        var r = Math.floor(k / A.cols), cc = k % A.cols;
        for (var y = 0; y < ny; y++) for (var i = 0; i < nx; i++) d[i + nx * (y + ny * k)] = px[((r * ny + y) * c.width + cc * nx + i) * 4];
      }
      var t3 = new THREE.DataTexture3D(d, nx, ny, nz);
      t3.format = THREE.RedFormat; t3.type = THREE.UnsignedByteType; t3.minFilter = t3.magFilter = THREE.LinearFilter; t3.unpackAlignment = 1; t3.needsUpdate = true;
      U.tAO = { value: t3 }; U.uAOo = { value: new THREE.Vector3(A.o[0], A.o[1], A.o[2]) }; U.uAOs = { value: new THREE.Vector3(A.s * nx, A.s * ny, A.s * nz) };
    }
    var sheetMat = new THREE.ShaderMaterial({ vertexShader: SHEET_VS, fragmentShader: SHEET_FS, uniforms: U, side: THREE.DoubleSide, depthWrite: false });
    var preMat = new THREE.ShaderMaterial({ vertexShader: SHEET_VS, fragmentShader: PRE_FS, uniforms: U, side: THREE.DoubleSide, colorWrite: false,
      polygonOffset: true, polygonOffsetFactor: 1, polygonOffsetUnits: 2 });
    var lineMat = new THREE.ShaderMaterial({ vertexShader: LINE_VS, fragmentShader: LINE_FS, uniforms: U, transparent: true, depthWrite: false });
    function solid(geo, parent) {          // depth first (the dissolve runs there), then colour on what is visible
      var pre = new THREE.Mesh(geo, preMat); pre.renderOrder = -2; parent.add(pre);
      var m = new THREE.Mesh(geo, sheetMat); parent.add(m); return m;
    }
    var parts = [], lparts = [];
    G.sheets.forEach(function (s, i) {
      parts.push({ g: extrude(shapesOf(s.polys), s.x, T, BEV), idx: i });
      var rings = []; s.polys.forEach(function (pl) { pl.forEach(function (r) { rings.push(ring(r)); }); });
      lparts.push({ rings: rings, x: s.x, idx: i });
    });
    solid(merge(parts), scene);
    LINES = new THREE.LineSegments(lineGeo(lparts), lineMat); LINES.renderOrder = 2; scene.add(LINES);

    BENCHG = new THREE.Group(); scene.add(BENCHG);
    var fs = G.sheets[FOCUS];
    solid(merge([{ g: extrude(shapesOf(fs.polys), 0, T, BEV), idx: BENCH }]), BENCHG);
    var bl = new THREE.LineSegments(lineGeo([{ rings: FR, x: T / 2 + 0.7, idx: BENCH }]), lineMat); bl.renderOrder = 2; BENCHG.add(bl);
    var board = new THREE.Shape([new THREE.Vector2(fz0 - BM, fy0 - BM), new THREE.Vector2(fz1 + BM, fy0 - BM), new THREE.Vector2(fz1 + BM, fy1 + BM), new THREE.Vector2(fz0 - BM, fy1 + BM)]);
    FR.forEach(function (r) { board.holes.push(new THREE.Path(r.slice())); });
    var slugs = [];
    fs.polys.forEach(function (pl) { for (var k = 1; k < pl.length; k++) slugs.push(new THREE.Shape(ring(pl[k]))); });
    OFFG = new THREE.Group(); BENCHG.add(OFFG);
    solid(merge([{ g: extrude([board].concat(slugs), 0, T, 1.0), idx: OFF }]), OFFG);
    KERF = makeKerf(FMAIN); BENCHG.add(KERF);
    SPARKS = makeSparks(); scene.add(SPARKS.points);
    TIP = makeTip(); scene.add(TIP);
    SPECS = makeSpecs(); scene.add(SPECS);
    SHADOW = makeShadow(); scene.add(SHADOW);
    ready = true;
    resize();
  }

  function makeKerf(r) {
    var n = r.length, len = [0], L = 0;
    for (var i = 1; i <= n; i++) { L += r[i % n].distanceTo(r[i - 1]); len.push(L); }
    var pos = [], at = [], idx = [], w = 2.2, x = T / 2 + 0.9;
    for (var j = 0; j <= n; j++) {
      var a = r[(j - 1 + n) % n], b = r[j % n], c = r[(j + 1) % n];
      var tx = c.x - a.x, ty = c.y - a.y, tl = Math.hypot(tx, ty) || 1, nx = -ty / tl, ny = tx / tl;
      pos.push(x, b.y + ny * w, b.x + nx * w, x, b.y - ny * w, b.x - nx * w);
      at.push(len[j] / L, len[j] / L);
      if (j < n) { var k = j * 2; idx.push(k, k + 1, k + 2, k + 1, k + 3, k + 2); }
    }
    var g = new THREE.BufferGeometry();
    g.setAttribute('position', new THREE.Float32BufferAttribute(pos, 3));
    g.setAttribute('aT', new THREE.Float32BufferAttribute(at, 1));
    g.setIndex(idx);
    var m = new THREE.Mesh(g, new THREE.ShaderMaterial({
      uniforms: { uTrace: { value: 0 }, uA: { value: 1 } }, transparent: true, depthWrite: false, side: THREE.DoubleSide,
      vertexShader: 'attribute float aT; varying float vT; void main(){ vT = aT; gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0); }',
      fragmentShader: ['precision highp float; uniform float uTrace; uniform float uA; varying float vT;',
        'void main(){ if (vT > uTrace || uA < 0.01) discard; float h = exp(-(uTrace - vT) * 26.0);',
        '  vec3 c = mix(vec3(0.16, 0.10, 0.07), mix(vec3(0.94, 0.35, 0.16), vec3(1.0, 0.86, 0.6), h * h), clamp(h * 1.6, 0.0, 1.0));',
        '  gl_FragColor = vec4(c, uA); }'].join('\n')
    }));
    m.renderOrder = 3;
    m.userData = { pts: r, len: len, L: L };
    return m;
  }
  function kerfPoint(t) {
    var d = KERF.userData, s = t * d.L, r = d.pts, n = r.length;
    for (var i = 1; i <= n; i++) if (d.len[i] >= s) { var u = (s - d.len[i - 1]) / Math.max(1e-6, d.len[i] - d.len[i - 1]), a = r[i - 1], b = r[i % n]; return new THREE.Vector3(T / 2 + 1.2, lerp(a.y, b.y, u), lerp(a.x, b.x, u)); }
    return new THREE.Vector3(T / 2 + 1.2, r[0].y, r[0].x);
  }
  function makeSparks() {
    var M = 260, pos = new Float32Array(M * 3), life = new Float32Array(M), vel = new Float32Array(M * 3), size = new Float32Array(M);
    var g = new THREE.BufferGeometry();
    g.setAttribute('position', new THREE.BufferAttribute(pos, 3));
    g.setAttribute('aL', new THREE.BufferAttribute(life, 1));
    g.setAttribute('aS', new THREE.BufferAttribute(size, 1));
    var pts = new THREE.Points(g, new THREE.ShaderMaterial({
      uniforms: { uPx: { value: 1 } }, transparent: true, depthWrite: false,
      vertexShader: 'attribute float aL; attribute float aS; uniform float uPx; varying float vL; void main(){ vL = aL; vec4 mv = modelViewMatrix * vec4(position, 1.0); gl_PointSize = aS * uPx * (2600.0 / -mv.z) * (0.4 + 0.6 * aL); gl_Position = projectionMatrix * mv; }',
      fragmentShader: 'precision highp float; varying float vL; void main(){ if (vL <= 0.0) discard; vec2 q = gl_PointCoord - 0.5; float a = smoothstep(0.5, 0.0, length(q)); gl_FragColor = vec4(mix(vec3(0.94, 0.30, 0.10), vec3(1.0, 0.80, 0.45), vL), a * min(1.0, vL * 1.6)); }'
    }));
    pts.frustumCulled = false; pts.renderOrder = 4;
    var head = 0;
    return {
      points: pts,
      emit: function (p, n) {
        for (var k = 0; k < n; k++) {
          var i = head; head = (head + 1) % M;
          pos[i * 3] = p.x; pos[i * 3 + 1] = p.y; pos[i * 3 + 2] = p.z;
          var a = Math.random() * Math.PI * 2, s = 140 + Math.random() * 380;
          vel[i * 3] = Math.cos(a) * s * 0.8; vel[i * 3 + 1] = Math.abs(Math.sin(a)) * s * 0.7 + 60; vel[i * 3 + 2] = 120 + Math.random() * 260;
          life[i] = 0.55 + Math.random() * 0.45; size[i] = 1.6 + Math.random() * 2.4;
        }
      },
      step: function (dt) {
        var any = false;
        for (var i = 0; i < M; i++) {
          if (life[i] <= 0) continue; any = true;
          life[i] -= dt * 1.7; vel[i * 3 + 1] -= 1500 * dt;
          pos[i * 3] += vel[i * 3] * dt; pos[i * 3 + 1] += vel[i * 3 + 1] * dt; pos[i * 3 + 2] += vel[i * 3 + 2] * dt;
        }
        g.attributes.position.needsUpdate = true; g.attributes.aL.needsUpdate = true; g.attributes.aS.needsUpdate = true;
        pts.visible = any;
      }
    };
  }
  function makeTip() {
    var g = new THREE.BufferGeometry(); g.setAttribute('position', new THREE.Float32BufferAttribute([0, 0, 0], 3));
    var m = new THREE.Points(g, new THREE.ShaderMaterial({
      uniforms: { uA: { value: 0 }, uPx: { value: 1 } }, transparent: true, depthWrite: false, depthTest: false,
      vertexShader: 'uniform float uPx; void main(){ vec4 mv = modelViewMatrix * vec4(position, 1.0); gl_PointSize = 70.0 * uPx * (2600.0 / -mv.z); gl_Position = projectionMatrix * mv; }',
      fragmentShader: 'precision highp float; uniform float uA; void main(){ float d = length(gl_PointCoord - 0.5) * 2.0; float a = exp(-d * d * 9.0) * 0.55 + exp(-d * d * 60.0); vec3 c = mix(vec3(0.94, 0.35, 0.16), vec3(1.0, 0.93, 0.8), exp(-d * d * 60.0)); gl_FragColor = vec4(c, clamp(a, 0.0, 1.0) * uA); }'
    }));
    m.frustumCulled = false; m.renderOrder = 5;
    return m;
  }
  function makeSpecs() {
    var sp = G.specs, parts = [];
    var shape = new THREE.Shape(ring(sp.rings[0]));
    for (var k = 1; k < sp.rings.length; k++) shape.holes.push(new THREE.Path(ring(sp.rings[k])));
    var g = new THREE.ExtrudeGeometry(shape, { depth: sp.t - 3, bevelEnabled: true, bevelThickness: 1.5, bevelSize: 1.5, bevelOffset: -1.5, bevelSegments: 2, curveSegments: 1 });
    g.translate(0, 0, sp.z + 1.5);
    parts.push(g.index ? g.toNonIndexed() : g);
    sp.temples.forEach(function (pts) {
      var curve = new THREE.CatmullRomCurve3(pts.map(function (q) { return new THREE.Vector3(q[0], q[1], q[2]); }), false, 'centripetal');
      parts.push(new THREE.TubeGeometry(curve, 36, 3.4, 8, false).toNonIndexed());
    });
    var pos = [], nor = [];
    parts.forEach(function (p) { pos.push.apply(pos, p.attributes.position.array); nor.push.apply(nor, p.attributes.normal.array); p.dispose(); });
    var G2 = new THREE.BufferGeometry();
    G2.setAttribute('position', new THREE.Float32BufferAttribute(pos, 3));
    G2.setAttribute('normal', new THREE.Float32BufferAttribute(nor, 3));
    return new THREE.Mesh(G2, new THREE.ShaderMaterial({
      uniforms: { uS: { value: 0 }, uOff: { value: new THREE.Vector3() } },
      vertexShader: 'uniform vec3 uOff; varying vec3 vP; varying vec3 vN; varying vec3 vW; void main(){ vP = position; vN = normal; vec4 w = modelMatrix * vec4(position + uOff, 1.0); vW = w.xyz; gl_Position = projectionMatrix * viewMatrix * w; }',
      fragmentShader: ['precision highp float; uniform float uS; varying vec3 vP; varying vec3 vN; varying vec3 vW;', NOISE,
        'void main(){ if (uS < 0.999) { float n = vn(vP * 0.12); if (n > uS * 1.1 - 0.05) discard; }',
        '  vec3 N = normalize(vN); if (!gl_FrontFacing) N = -N; vec3 V = normalize(cameraPosition - vW);',
        '  vec3 L1 = normalize(vec3(-0.55, 0.72, 0.62)); float d = max(dot(N, L1), 0.0);',
        '  vec3 c = vec3(0.925, 0.894, 0.824) * (0.42 + 0.62 * d + 0.12 * (0.5 + 0.5 * N.y));',
        '  c += pow(max(dot(reflect(-L1, N), V), 0.0), 20.0) * 0.08;',
        '  gl_FragColor = vec4(c, 1.0); }'].join('\n'),
      side: THREE.DoubleSide
    }));
  }
  function makeShadow() {
    var g = new THREE.PlaneGeometry(1, 1); g.rotateX(-Math.PI / 2);
    var m = new THREE.Mesh(g, new THREE.ShaderMaterial({
      uniforms: { uA: { value: 0.3 } }, transparent: true, depthWrite: false,
      vertexShader: 'varying vec2 vU; void main(){ vU = uv; gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0); }',
      fragmentShader: 'precision highp float; uniform float uA; varying vec2 vU; void main(){ vec2 q = (vU - 0.5) * 2.0; float d = length(q); float a = smoothstep(1.0, 0.0, d); a = a * a * (0.55 + 0.45 * smoothstep(0.55, 0.0, d)); gl_FragColor = vec4(0.067, 0.063, 0.055, a * uA); }'
    }));
    m.position.set(0, -1, 10); m.renderOrder = -1;
    return m;
  }

  /* ---------------------------------------------------------------- camera */
  var TANH = function (fov) { return Math.tan(THREE.MathUtils.degToRad(fov / 2)); };
  function frame(s) {
    var d = H / (s.h * 2 * TANH(s.fov)), az = THREE.MathUtils.degToRad(s.az), el = THREE.MathUtils.degToRad(s.el);
    cam.fov = s.fov; cam.near = d * 0.05; cam.far = d * 6; cam.updateProjectionMatrix();
    cam.position.set(s.tx + d * Math.sin(az) * Math.cos(el), s.ty + d * Math.sin(el), s.tz + d * Math.cos(az) * Math.cos(el));
    cam.lookAt(s.tx, s.ty, s.tz);
    cam.setViewOffset(VIEW.w, VIEW.h, VIEW.w * (0.5 - s.fx), VIEW.h * (0.5 - s.fy), VIEW.w, VIEW.h);
  }
  function mix(a, b, t) { var o = {}; for (var k in a) o[k] = lerp(a[k], b[k], t); return o; }
  var BX = 0, BZ = 420;
  var KEYS = null;
  function keys() {
    var ph = phone(), k = ph ? 0.62 : 1, R = RS;
    // front: exactly where the bust stands in the photograph
    var F0 = { az: 0, el: 0, h: R.hf, fov: 12, tx: W / 2 - PX, ty: H / 2, tz: ZC, fx: R.fx, fy: R.fy };
    var fx3 = ph ? 0.5 : R.fx, fy3 = ph ? 0.58 : R.fy;
    var C = { tx: 0, ty: H / 2, tz: 70, fx: fx3, fy: fy3, fov: 24 };
    var B = { tx: BX - 20, ty: (fy0 + fy1) / 2, tz: BZ, fx: fx3, fy: fy3, fov: 24 };
    function K(p, o, base) { var s = {}, x; for (x in base) s[x] = base[x]; for (x in o) s[x] = o[x]; s.h *= k; return [p, s]; }
    return [
      [0.0, F0], [0.375, F0],
      K(0.42, { az: 34, el: 9, h: 0.64, fov: 22 }, C),
      K(0.50, { az: 64, el: 13, h: 0.4, fov: 26 }, C),
      K(0.55, { az: 10, el: 4, h: 0.7 }, B),
      K(0.64, { az: 7, el: 3, h: 0.76 }, B),
      K(0.66, { az: 9, el: 4, h: 0.7 }, B),
      K(0.70, { az: 58, el: 12, h: 0.42, fov: 26 }, C),
      K(0.72, { az: 56, el: 12, h: 0.44, fov: 26 }, C),
      K(0.795, { az: 30, el: 8, h: 0.68, fov: 22 }, C),
      K(0.85, { az: 18, el: 5, h: 0.7, fov: 20 }, C),
      [0.895, F0], [1.0, F0]
    ];
  }
  function camAt(q) {
    var ks = KEYS;
    if (q <= ks[0][0]) return mix(ks[0][1], ks[0][1], 0);
    for (var i = 1; i < ks.length; i++) if (q <= ks[i][0]) return mix(ks[i - 1][1], ks[i][1], eio(seg(q, ks[i - 1][0], ks[i][0])));
    return mix(ks[ks.length - 1][1], ks[ks.length - 1][1], 0);
  }

  /* ---------------------------------------------------------------- the 3D story as a function of scroll progress p */
  var ORDER = SX.map(function (x) { return Math.abs(x) / 320; });
  var FDIST = SX.map(function (x, i) { return Math.abs(i - FOCUS) / Math.max(FOCUS, N - 1 - FOCUS); });
  var ST = { drawn: 0, trace: 0, set: 0 }, lastTrace = 0;
  var TL = { draw: [0.31, 0.37], spread: [0.43, 0.5], out: [0.52, 0.55], board: [0.545, 0.565], trace: [0.565, 0.64], drop: [0.64, 0.66], back: [0.66, 0.685],
    ripple: [0.685, 0.715], asm: [0.715, 0.795], finish: [0.8, 0.855], spec: [0.85, 0.875], sweep: [0.86, 0.895] };
  var tl = function (q, k) { return seg(q, TL[k][0], TL[k][1]); };
  function apply(q, dt) {
    var draw = tl(q, 'draw'), spread = sm(tl(q, 'spread')) * SPREAD;
    var out = sm(tl(q, 'out')), boardIn = tl(q, 'board'), trace = tl(q, 'trace'), drop = tl(q, 'drop'), back = sm(tl(q, 'back'));
    var ripple = tl(q, 'ripple'), asm = tl(q, 'asm'), finish = tl(q, 'finish'), specIn = tl(q, 'spec'), sweep = tl(q, 'sweep');
    var benchOn = q > TL.out[0] && q < TL.back[1], solidsOn = q >= TL.back[1];
    var lineBase = q < TL.out[0] ? 0.78 : lerp(0.78, 0.22, seg(q, TL.out[0], TL.out[0] + 0.04));
    var drawn = 0, set = 0;
    for (var i = 0; i < N; i++) {
      var a = UA[i], b = UB[i], x = SX[i];
      var o = i / (N - 1) * 0.8, la = clamp((draw - o) / 0.2, 0, 1);
      if (la > 0.5) drawn++;
      var S = spread; b.x = 0;
      if (q >= TL.asm[0]) { var u = clamp((asm - ORDER[i] * 0.36) / 0.64, 0, 1); S = SPREAD * (1 - eob(u)); if (u >= 1) set++; b.x = u > 0.6 && u < 1 ? bump(u - 0.93, 0.05) * 0.2 : 0; }
      var r = clamp((ripple - FDIST[i] * 0.72) / 0.28, 0, 1);
      var solid, line;
      if (!solidsOn) { solid = 0; line = la * lineBase; }
      else { solid = r; line = (1 - r) * 0.22; if (r > 0 && r < 1) b.x = Math.max(b.x, bump(r - 0.45, 0.22) * 0.3); }
      if (i === FOCUS && benchOn) { solid = 0; line = 0; }
      if (i === FOCUS && solidsOn) solid = 1;
      a.set(x * S, 0, solid, 1);
      b.y = line; b.z = draw < 1 ? bump(draw - o - 0.07, 0.05) : 0; b.w = 1 - S / SPREAD;
    }
    UA[BENCH].set(0, 0, boardIn, 1); UB[BENCH].set(0, out > 0 && trace < 1 ? 0.9 * (1 - seg(q, TL.trace[1] - 0.012, TL.trace[1])) : 0, 0, 0);
    UA[OFF].set(0, 0, boardIn * (1 - seg(q, TL.drop[1] - 0.012, TL.drop[1])), 1); UB[OFF].set(0, 0, 0, 0);
    if (ready) {
      BENCHG.visible = benchOn;
      var fx = SX[FOCUS] * (1 + SPREAD), k = out * (1 - back);
      BENCHG.position.set(lerp(fx, BX + (fz0 + fz1) / 2, k), Math.sin(k * Math.PI) * 50, lerp(0, BZ, k));
      BENCHG.rotation.y = -Math.PI / 2 * k;
      OFFG.position.set(0, -drop * drop * 760, 0); OFFG.rotation.x = drop * drop * 0.55;
      KERF.material.uniforms.uTrace.value = trace; KERF.material.uniforms.uA.value = 1 - back;
      var tipOn = trace > 0 && trace < 1 && benchOn;
      TIP.material.uniforms.uA.value = tipOn ? 1 : 0;
      if (tipOn) {
        BENCHG.updateMatrixWorld();
        var wp = kerfPoint(trace).applyMatrix4(BENCHG.matrixWorld);
        TIP.position.copy(wp);
        var dd = Math.abs(trace - lastTrace);
        if (dd > 0 && dd < 0.2) SPARKS.emit(wp, Math.min(14, 2 + Math.round(dd * 900)));
      }
      lastTrace = trace;
      SPARKS.step(dt);
      SPECS.material.uniforms.uS.value = specIn; SPECS.material.uniforms.uOff.value.set(0, (1 - eo3(specIn)) * 140, 0); SPECS.visible = specIn > 0.001;
      var Sm = q >= TL.asm[0] ? SPREAD * (1 - asm) : spread;
      SHADOW.scale.set(760 * (1 + Sm * 0.9), 1, 470); SHADOW.material.uniforms.uA.value = 0.26 * (benchOn ? 0.5 : solidsOn ? 1 : 0.35);
    }
    U.uFin.value = lerp(-70, H + 70, sm(finish));
    U.uBand.value = finish > 0 && finish < 1 ? 1 : 0;
    U.uSweep.value = lerp(-520, 520, sweep); U.uSweepA.value = sweep > 0 && sweep < 1 ? Math.sin(sweep * Math.PI) : 0;
    ST.drawn = drawn; ST.trace = trace; ST.set = set; ST.draw = draw;
  }

  /* ---------------------------------------------------------------- the carved block (the usual way), drawn on a 2D canvas */
  var CV = $('#f-carve'), CK = null;
  var BK = { x0: -34, y0: -42, x1: 686, y1: 883 };
  function buildCarve(silIm) {
    var bw = BK.x1 - BK.x0, bh = BK.y1 - BK.y0, R = mulberry(11);
    var sc = document.createElement('canvas'); sc.width = W; sc.height = H;
    var sx = sc.getContext('2d'); sx.drawImage(silIm, 0, 0);
    var sd = sx.getImageData(0, 0, W, H).data, silA = new Uint8Array(W * H);
    for (var i = 0; i < W * H; i++) silA[i] = sd[i * 4];
    var silMask = document.createElement('canvas'); silMask.width = W; silMask.height = H;
    var smx = silMask.getContext('2d'), mid = smx.createImageData(W, H);
    for (var i2 = 0; i2 < W * H; i2++) { mid.data[i2 * 4] = 17; mid.data[i2 * 4 + 1] = 16; mid.data[i2 * 4 + 2] = 14; mid.data[i2 * 4 + 3] = silA[i2]; }
    smx.putImageData(mid, 0, 0);
    var silAt = function (x, y) { x = Math.round(x); y = Math.round(y); return x < 0 || y < 0 || x >= W || y >= H ? 0 : silA[y * W + x]; };
    var q = 4, gw = Math.ceil((bw + 2) / q), gh = Math.ceil((bh + 2) / q), dist = new Float32Array(gw * gh), x, y, kk, v;
    for (y = 0; y < gh; y++) for (x = 0; x < gw; x++) dist[y * gw + x] = silAt(BK.x0 + x * q, BK.y0 + y * q) > 127 ? 0 : 1e9;
    for (y = 0; y < gh; y++) for (x = 0; x < gw; x++) { kk = y * gw + x; v = dist[kk]; if (x > 0) v = Math.min(v, dist[kk - 1] + 1); if (y > 0) v = Math.min(v, dist[kk - gw] + 1); if (x > 0 && y > 0) v = Math.min(v, dist[kk - gw - 1] + 1.414); if (x < gw - 1 && y > 0) v = Math.min(v, dist[kk - gw + 1] + 1.414); dist[kk] = v; }
    for (y = gh - 1; y >= 0; y--) for (x = gw - 1; x >= 0; x--) { kk = y * gw + x; v = dist[kk]; if (x < gw - 1) v = Math.min(v, dist[kk + 1] + 1); if (y < gh - 1) v = Math.min(v, dist[kk + gw] + 1); if (x < gw - 1 && y < gh - 1) v = Math.min(v, dist[kk + gw + 1] + 1.414); if (x > 0 && y < gh - 1) v = Math.min(v, dist[kk + gw - 1] + 1.414); dist[kk] = v; }
    var distAt = function (x, y) { var gx = clamp(Math.round((x - BK.x0) / q), 0, gw - 1), gy = clamp(Math.round((y - BK.y0) / q), 0, gh - 1); return dist[gy * gw + gx] * q; };

    // the wood: warm block, long grain, one knot
    var wood = document.createElement('canvas'); wood.width = bw; wood.height = bh;
    var wx = wood.getContext('2d');
    var gr = wx.createLinearGradient(0, 0, bw, bh); gr.addColorStop(0, '#C79A69'); gr.addColorStop(1, '#A87A4C');
    wx.fillStyle = gr; wx.fillRect(0, 0, bw, bh);
    var KX = bw * 0.7, KY = bh * 0.7;
    for (var l = 0; l < 190; l++) {
      var x0 = R() * (bw + 80) - 40, a1 = 4 + R() * 12, f1 = 0.004 + R() * 0.008, ph = R() * 6.28, a2 = 1 + R() * 3, f2 = 0.03 + R() * 0.03;
      wx.beginPath();
      for (y = -10; y <= bh + 10; y += 6) {
        var dx = x0 - KX, dy = y - KY, rr = Math.sqrt(dx * dx + dy * dy * 0.25) + 1;
        var xx = x0 + Math.sin(y * f1 + ph) * a1 + Math.sin(y * f2 + ph * 2) * a2 + 2600 / (rr + 30) * Math.sign(dx || 1);
        if (y === -10) wx.moveTo(xx, y); else wx.lineTo(xx, y);
      }
      wx.strokeStyle = 'rgba(' + (88 + R() * 30 | 0) + ',' + (52 + R() * 18 | 0) + ',' + (24 + R() * 12 | 0) + ',' + (0.06 + R() * 0.2).toFixed(3) + ')';
      wx.lineWidth = 0.5 + R() * 2.2; wx.stroke();
    }
    for (var kn = 0; kn < 9; kn++) { wx.beginPath(); wx.ellipse(KX, KY, 5 + kn * 5.5, 12 + kn * 10, 0.08, 0, 6.283); wx.strokeStyle = 'rgba(80,44,18,' + (0.42 - kn * 0.04) + ')'; wx.lineWidth = 1.4; wx.stroke(); }
    wx.beginPath(); wx.ellipse(KX, KY, 5, 10, 0.08, 0, 6.283); wx.fillStyle = 'rgba(70,36,14,.75)'; wx.fill();
    for (var sp = 0; sp < 2600; sp++) { wx.fillStyle = 'rgba(70,40,18,' + (R() * 0.12).toFixed(3) + ')'; wx.fillRect(R() * bw, R() * bh, 1 + R() * 2, 1); }
    var tg = wx.createLinearGradient(0, 0, 0, 34); tg.addColorStop(0, 'rgba(255,240,215,.35)'); tg.addColorStop(1, 'rgba(255,240,215,0)');
    wx.fillStyle = tg; wx.fillRect(0, 0, bw, 34);

    // chunks: a jittered grid with shared corners, so they tile the block exactly
    var TS = 30, cols = Math.ceil(bw / TS), rows = Math.ceil(bh / TS), V = [], r, c;
    for (r = 0; r <= rows; r++) { V.push([]); for (c = 0; c <= cols; c++) {
      x = Math.min(c * TS, bw); y = Math.min(r * TS, bh);
      if (c > 0 && c < cols) x += (R() - 0.5) * TS * 0.7; if (r > 0 && r < rows) y += (R() - 0.5) * TS * 0.7;
      V[r].push([x + BK.x0, y + BK.y0]);
    } }
    var tiles = [], dmax = 1, total = 0;
    for (r = 0; r < rows; r++) for (c = 0; c < cols; c++) {
      var pts = [V[r][c], V[r][c + 1], V[r + 1][c + 1], V[r + 1][c]], cx = 0, cy = 0, ar = 0;
      pts.forEach(function (p, j) { var p2 = pts[(j + 1) % 4]; cx += p[0] / 4; cy += p[1] / 4; ar += p[0] * p2[1] - p2[0] * p[1]; });
      ar = Math.abs(ar) / 2;
      var inside = 0, n = 0;
      for (var a = 0.1; a < 1; a += 0.2) for (var bq = 0.1; bq < 1; bq += 0.2) {
        var px = lerp(lerp(pts[0][0], pts[1][0], a), lerp(pts[3][0], pts[2][0], a), bq), py = lerp(lerp(pts[0][1], pts[1][1], a), lerp(pts[3][1], pts[2][1], a), bq);
        inside += silAt(px, py) > 127 ? 1 : 0; n++;
      }
      var cov = inside / n, d = distAt(cx, cy);
      dmax = Math.max(dmax, d); total += ar;
      tiles.push({ pts: pts, cx: cx, cy: cy, cov: cov, d: d, t: 0, gone: false, shade: (R() - 0.5), waste: ar * (1 - cov) });
    }
    tiles.forEach(function (t) {
      if (t.cov >= 1) t.t = 9;
      else if (t.cov > 0) t.t = 0.74 + R() * 0.14;
      else t.t = 0.03 + 0.64 * Math.pow(1 - t.d / dmax, 1.15) + R() * 0.08;
    });
    var carved = document.createElement('canvas'); carved.width = bw; carved.height = bh;
    var cx2 = carved.getContext('2d');
    cx2.drawImage(wood, 0, 0);
    tiles.forEach(function (t) {
      cx2.beginPath(); t.pts.forEach(function (p, j) { var X = p[0] - BK.x0, Y = p[1] - BK.y0; if (j) cx2.lineTo(X, Y); else cx2.moveTo(X, Y); }); cx2.closePath();
      cx2.fillStyle = t.shade > 0 ? 'rgba(255,236,205,' + (t.shade * 0.22).toFixed(3) + ')' : 'rgba(60,30,10,' + (-t.shade * 0.26).toFixed(3) + ')';
      cx2.fill();
    });
    var rim = document.createElement('canvas'); rim.width = bw; rim.height = bh;
    var rx = rim.getContext('2d'); rx.fillStyle = '#3b2210'; rx.fillRect(0, 0, bw, bh); rx.globalCompositeOperation = 'destination-out'; rx.drawImage(silMask, -BK.x0, -BK.y0);
    cx2.globalCompositeOperation = 'destination-in'; cx2.drawImage(silMask, -BK.x0, -BK.y0);
    cx2.globalCompositeOperation = 'source-atop'; cx2.globalAlpha = 0.55; try { cx2.filter = 'blur(7px)'; } catch (e) { /* no canvas filters */ }
    cx2.drawImage(rim, 0, 0); cx2.filter = 'none'; cx2.globalAlpha = 1; cx2.globalCompositeOperation = 'source-over';
    // cached layers: the block as it stands (updated one chunk at a time) and the wood still covering the inside
    var tilePath = function (t) { var p = new Path2D(); t.pts.forEach(function (q, j) { var X = q[0] - BK.x0, Y = q[1] - BK.y0; if (j) p.lineTo(X, Y); else p.moveTo(X, Y); }); p.closePath(); return p; };
    var comp = document.createElement('canvas'); comp.width = bw; comp.height = bh;
    var cc2 = comp.getContext('2d'), keep = new Path2D(), inner = new Path2D();
    tiles.forEach(function (t) { t.path = tilePath(t); (t.cov >= 1 ? inner : keep).addPath(t.path); });
    cc2.drawImage(carved, 0, 0); cc2.save(); cc2.clip(keep); cc2.drawImage(wood, 0, 0); cc2.restore();
    var woodIn = document.createElement('canvas'); woodIn.width = bw; woodIn.height = bh;
    var wi = woodIn.getContext('2d'); wi.save(); wi.clip(inner); wi.drawImage(wood, 0, 0); wi.restore();
    CK = { wood: wood, carved: carved, comp: comp, woodIn: woodIn, tiles: tiles, chips: [], total: total, last: -1, lastA: -1, R: R, removed: 0, gone: 0 };
  }
  function drawCarve(c, alpha, dt) {
    if (!CK) return;
    if (Math.abs(c - CK.last) < 1e-4 && Math.abs(alpha - CK.lastA) < 1e-3 && !CK.chips.length) return;
    var forward = c > CK.last && CK.last >= 0;
    var x = CV.getContext('2d'), d = VIEW.dpr, R = RS;
    x.setTransform(1, 0, 0, 1, 0, 0); x.clearRect(0, 0, CV.width, CV.height);
    if (alpha <= 0.001) { CK.last = c; CK.lastA = alpha; CK.chips.length = 0; return; }
    x.setTransform(R.s * d, 0, 0, R.s * d, (R.cx - W / 2 * R.s) * d, (R.cy - H / 2 * R.s) * d);
    x.globalAlpha = alpha;
    x.save(); x.translate(W / 2 - 40, BK.y1 + 2); x.scale(1, 0.09);
    var sg = x.createRadialGradient(0, 0, 0, 0, 0, 470); sg.addColorStop(0, 'rgba(30,20,10,.55)'); sg.addColorStop(0.6, 'rgba(30,20,10,.22)'); sg.addColorStop(1, 'rgba(30,20,10,0)');
    x.fillStyle = sg; x.beginPath(); x.arc(0, 0, 470, 0, 6.2832); x.fill(); x.restore();
    var fade = 1 - sm(seg(c, 0.8, 0.97)), cc = CK.comp.getContext('2d');
    var off = { p: new Path2D(), b: [1e9, 1e9, -1e9, -1e9], n: 0 }, on = { p: new Path2D(), b: [1e9, 1e9, -1e9, -1e9], n: 0 };
    CK.tiles.forEach(function (t) {
      if (t.cov >= 1) return;
      var gone = c > t.t;
      if (gone === t.gone) return;
      if (gone && forward && alpha > 0.5) spawnChips(t);
      t.gone = gone; CK.removed += (gone ? 1 : -1) * t.waste / CK.total;
      var g = gone ? off : on; g.p.addPath(t.path); g.n++;
      t.pts.forEach(function (q) { var X = q[0] - BK.x0, Y = q[1] - BK.y0; g.b[0] = Math.min(g.b[0], X); g.b[1] = Math.min(g.b[1], Y); g.b[2] = Math.max(g.b[2], X); g.b[3] = Math.max(g.b[3], Y); });
    });
    // only the chunks that changed this frame, and only their own area: down to the carved form, or wood back
    [[off, true], [on, false]].forEach(function (o) {
      var g = o[0]; if (!g.n) return;
      var x0 = Math.max(0, Math.floor(g.b[0]) - 1), y0 = Math.max(0, Math.floor(g.b[1]) - 1);
      var w = Math.min(CK.comp.width, Math.ceil(g.b[2]) + 1) - x0, h = Math.min(CK.comp.height, Math.ceil(g.b[3]) + 1) - y0;
      if (w <= 0 || h <= 0) return;
      cc.save(); cc.clip(g.p);
      if (o[1]) { cc.clearRect(x0, y0, w, h); cc.drawImage(CK.carved, x0, y0, w, h, x0, y0, w, h); } else cc.drawImage(CK.wood, x0, y0, w, h, x0, y0, w, h);
      cc.restore();
    });
    x.drawImage(CK.comp, BK.x0, BK.y0);
    if (fade > 0.001) { x.globalAlpha = fade * alpha; x.drawImage(CK.woodIn, BK.x0, BK.y0); }
    x.globalAlpha = alpha;
    for (var i = CK.chips.length - 1; i >= 0; i--) {
      var ch = CK.chips[i];
      ch.vy += 1500 * dt; ch.x += ch.vx * dt; ch.y += ch.vy * dt; ch.r += ch.vr * dt; ch.life -= dt;
      if (ch.y > BK.y1 + 400 || ch.life <= 0) { CK.chips.splice(i, 1); continue; }
      x.save(); x.translate(ch.x, ch.y); x.rotate(ch.r); x.fillStyle = ch.col;
      x.beginPath(); x.moveTo(-ch.s, -ch.s * 0.4); x.lineTo(ch.s * 0.9, -ch.s * 0.6); x.lineTo(ch.s * 0.3, ch.s * 0.7); x.closePath(); x.fill(); x.restore();
    }
    x.globalAlpha = 1;
    CK.removed = Math.max(0, CK.removed); CK.last = c; CK.lastA = alpha;
  }
  function spawnChips(t) {
    var n = 2 + (CK.R() * 3 | 0), R = CK.R;
    for (var k = 0; k < n; k++) {
      var dx = t.cx - W / 2, dy = t.cy - H * 0.45, l = Math.hypot(dx, dy) || 1, s = 220 + R() * 420;
      CK.chips.push({ x: t.cx + (R() - 0.5) * 20, y: t.cy + (R() - 0.5) * 20, vx: dx / l * s + (R() - 0.5) * 160, vy: dy / l * s * 0.5 - 260 - R() * 260,
        r: R() * 6, vr: (R() - 0.5) * 18, s: 4 + R() * 9, life: 1.8, col: R() > 0.5 ? '#B98A58' : '#9C6E42' });
    }
    if (CK.chips.length > 420) CK.chips.splice(0, CK.chips.length - 420);
  }

  /* ---------------------------------------------------------------- captions and chapters */
  var CAPS = $$('.cap').map(function (el) { return { el: el, w: el.getAttribute('data-w').split(',').map(Number), last: '' }; });
  function layoutCaps() {
    var bl = WS.ox + BB[0] * WS.s, g = clamp(VIEW.w * 0.034, 16, 48);
    var cw = clamp(bl - g - 50, 320, 780);
    STAGE.style.setProperty('--cx', g.toFixed(0) + 'px'); STAGE.style.setProperty('--cw', cw.toFixed(0) + 'px');
    CAPS.forEach(function (c) { c.last = ''; });
  }
  var INTRO_T = null;
  function caps(p, time) {
    var ph = phone(), intro = INTRO_T === null ? 0 : clamp((time - INTRO_T) / 1.4, 0, 1);
    CAPS.forEach(function (c) {
      var w = c.w, a = w[0] < 0 ? eo3(intro) : seg(p, w[0], w[1]), b = seg(p, w[2], w[3]), v = a * (1 - b);
      var key = v.toFixed(3) + '|' + a.toFixed(3);
      if (key === c.last) return; c.last = key;
      var vis = v > 0.002;
      c.el.style.visibility = vis ? 'visible' : 'hidden';
      if (!vis) return;
      var dy = (1 - eo3(a)) * 22 - eio(b) * 22;
      c.el.style.opacity = sm(v).toFixed(3);
      c.el.style.filter = v > 0.995 ? 'none' : 'blur(' + ((1 - v) * 12).toFixed(1) + 'px)';
      c.el.style.transform = ph ? 'translate3d(0,' + dy.toFixed(1) + 'px,0)' : 'translate3d(0,calc(-50% + ' + dy.toFixed(1) + 'px),0)';
    });
  }
  var CH = [['Intro', 0], ['The usual way', 0.152], ['A drawing', 0.33], ['Slice', 0.425], ['Cut', 0.52], ['Assemble', 0.685], ['Finish', 0.802], ['Composed', 0.945]];
  var DOTS = $('#dots'), CHN = $('#chap-name'), CALL = $('#callout'), BRK = $('#brk'), WIPE = $('#wipe');
  CH.forEach(function (c, i) {
    var b = document.createElement('button'); b.type = 'button'; b.innerHTML = '<span>' + pad(i, 2) + ' ' + c[0] + '</span><i></i>';
    b.setAttribute('aria-label', 'Go to ' + c[0]);
    b.addEventListener('click', function () { goP(i === 0 ? 0 : c[1] + 0.012); });
    DOTS.appendChild(b);
  });
  var DOTB = $$('button', DOTS), chLast = -1, HINT = $('#scroll-hint');
  HINT.addEventListener('click', function (e) { e.preventDefault(); goP(0.08); });
  function goP(p) {
    var max = document.documentElement.scrollHeight - innerHeight;
    if (lenis) lenis.scrollTo(p * max, { duration: 2.2, easing: eio }); else window.scrollTo(0, p * max);
  }
  var vtmp = new THREE.Vector3();
  function project(x, y, z, m) { vtmp.set(x, y, z); if (m) vtmp.applyMatrix4(m); vtmp.project(cam); return [(vtmp.x * 0.5 + 0.5) * VIEW.w, (-vtmp.y * 0.5 + 0.5) * VIEW.h]; }
  function overlay(p, time) {
    caps(p, time);
    var k = 0; CH.forEach(function (c, i) { if (p >= c[1] - 0.002) k = i; });
    if (k !== chLast) { DOTB.forEach(function (b, i) { b.classList.toggle('on', i === k); }); CHN.textContent = CH[k][0]; chLast = k; }
    var hint = 1 - seg(p, 0.004, 0.03);
    HINT.style.opacity = document.body.classList.contains('intro') ? '' : hint.toFixed(3); HINT.style.pointerEvents = hint > 0.5 ? 'auto' : 'none';
    // label + corner brackets on the plane being cut
    var co = seg(p, 0.548, 0.562) * (1 - seg(p, 0.642, 0.656));
    CALL.style.opacity = co.toFixed(3); BRK.style.opacity = co.toFixed(3);
    if (co > 0 && ready) {
      BENCHG.updateMatrixWorld();
      var m = BENCHG.matrixWorld, xs = [], ys = [];
      [[fz0 - BM, fy0 - BM], [fz1 + BM, fy0 - BM], [fz1 + BM, fy1 + BM], [fz0 - BM, fy1 + BM]].forEach(function (q) { var s = project(T / 2, q[1], q[0], m); xs.push(s[0]); ys.push(s[1]); });
      var l = Math.min.apply(0, xs) - 14, t = Math.min.apply(0, ys) - 14, r = Math.max.apply(0, xs) + 14, b = Math.max.apply(0, ys) + 14;
      BRK.style.transform = 'translate3d(' + l.toFixed(1) + 'px,' + t.toFixed(1) + 'px,0)'; BRK.style.width = (r - l).toFixed(1) + 'px'; BRK.style.height = (b - t).toFixed(1) + 'px';
      CALL.style.left = ((l + r) / 2).toFixed(1) + 'px'; CALL.style.top = (t - 6).toFixed(1) + 'px';
      CALL.innerHTML = 'Profile ' + pad(FOCUS + 1, 3) + ' <span class="k">■</span> ' + (ST.trace >= 1 ? 'cut' : ST.trace > 0 ? 'cutting' : 'drawn');
    }
  }

  /* ---------------------------------------------------------------- the opening: a loading line, then a window onto the piece */
  var heroLast = '';
  function hero(p, k, time) {
    var t = INTRO_T === null ? -1 : time - INTRO_T;
    var open = sm(seg(t, 0.15, 1.45)), words = seg(t, 0.95, 2.0);
    if (t >= 0 && !LOADER.classList.contains('gone')) LOADER.classList.add('gone');
    if (t > 1.6) document.body.classList.remove('intro');
    // the opening: a small tilted window onto the scene that grows to fill the screen
    var key = open.toFixed(4) + '|' + VIEW.w + '|' + VIEW.h;
    if (key !== heroLast) {
      heroLast = key;
      var eo = eio(open);
      var x = lerp(WIN.x, 0, eo), y = lerp(WIN.y, 0, eo), w = lerp(WIN.w, VIEW.w, eo), h = lerp(WIN.h, VIEW.h, eo), r = lerp(WIN.r, 0, eo);
      SCN.style.opacity = t < 0 ? 0 : Math.min(1, open * 4).toFixed(3);
      SCN.style.clipPath = open >= 1 ? 'none' : 'inset(' + y.toFixed(1) + 'px ' + (VIEW.w - x - w).toFixed(1) + 'px ' + (VIEW.h - y - h).toFixed(1) + 'px ' + x.toFixed(1) + 'px round ' + r.toFixed(1) + 'px)';
      SCN.style.transformOrigin = (VIEW.w / 2).toFixed(1) + 'px ' + (VIEW.h / 2).toFixed(1) + 'px';
      SCN.style.transform = open >= 1 ? 'none' : 'rotate(' + lerp(-6, 0, eo).toFixed(3) + 'deg)';
    }
    // the tagline rises into place, then parts as the window opens; a touch of depth with the cursor
    var out = seg(p, 0, 0.05), vis = 1 - out, ph = phone();
    var w1 = eo3(clamp(words * 1.4, 0, 1)), w2 = eo3(clamp(words * 1.4 - 0.25, 0, 1));
    HT1.style.transform = 'translate3d(0,' + ((1 - w1) * 110).toFixed(1) + '%,0)';
    HT2.style.transform = 'translate3d(0,' + ((1 - w2) * 110).toFixed(1) + '%,0)';
    HLS.forEach(function (el) { el.style.opacity = (seg(words, 0.5, 1) * vis).toFixed(3); });
    var mx = mouse.sx, my = mouse.sy;
    HTOP.style.transform = 'translate3d(' + (mx * -58).toFixed(1) + 'px,' + (-k * VIEW.h * 0.35 + my * -30).toFixed(1) + 'px,0)';
    HBOT.style.transform = 'translate3d(' + (mx * -112).toFixed(1) + 'px,' + (k * VIEW.h * 0.2 + my * -54).toFixed(1) + 'px,0)';
    HTOP.style.opacity = HBOT.style.opacity = vis.toFixed(3);
    HTOP.style.visibility = HBOT.style.visibility = vis > 0.001 ? 'visible' : 'hidden';
  }

  /* ---------------------------------------------------------------- dust in the light: specks at different depths drift, and slide with the cursor */
  var DX = DUST.getContext('2d'), MOTES = [];
  (function () {
    var R = mulberry(9);
    for (var i = 0; i < 90; i++) MOTES.push({ x: R(), y: R(), d: 0.25 + R() * 1.1, r: 0.5 + R() * 1.5, a: 0.18 + R() * 0.5, vx: (R() - 0.5) * 0.006, vy: -0.004 - R() * 0.008, ph: R() * 6.28 });
  })();
  function dustSize() { DUST.width = Math.round(VIEW.w * Math.min(VIEW.dpr, 1.5)); DUST.height = Math.round(VIEW.h * Math.min(VIEW.dpr, 1.5)); }
  var dustOn = true;
  function dust(dt, time, hv) {
    var on = hv > 0.002 && INTRO_T !== null;
    if (!on) { if (dustOn) { DX.clearRect(0, 0, DUST.width, DUST.height); dustOn = false; } return; }
    dustOn = true;
    var w = DUST.width, h = DUST.height, sc = w / VIEW.w, bx = (WM.ox + BCX * WM.s) / VIEW.w;   // the light falls just right of the piece
    DX.clearRect(0, 0, w, h);
    MOTES.forEach(function (m) {
      m.x += (m.vx + Math.sin(time * 0.6 + m.ph) * 0.0015) * dt * 6; m.y += m.vy * dt * 6;
      if (m.y < -0.05) { m.y = 1.05; m.x = Math.random(); }
      if (m.x < -0.05) m.x = 1.05; if (m.x > 1.05) m.x = -0.05;
      var px = (m.x * VIEW.w - mouse.sx * 130 * m.d) * sc, py = (m.y * VIEW.h - mouse.sy * 60 * m.d) * sc;
      var beam = Math.exp(-Math.pow((m.x - bx - 0.12 + (m.y - 0.5) * 0.3) / 0.16, 2));          // brighter inside the shaft of light
      var a = m.a * (0.25 + 0.75 * beam) * hv * (0.7 + 0.3 * Math.sin(time * 1.3 + m.ph));
      DX.fillStyle = 'rgba(255,246,228,' + a.toFixed(3) + ')';
      DX.beginPath(); DX.arc(px, py, m.r * m.d * sc, 0, 6.2832); DX.fill();
    });
  }

  // a pill that trails the cursor over the hero, like a label hung on it
  var PX_ = { x: -200, y: -200, vx: 0, on: false, seen: false };
  var finePointer = matchMedia('(hover: hover) and (pointer: fine)').matches;
  addEventListener('pointermove', function (e) { PX_.tx = e.clientX; PX_.ty = e.clientY; if (!PX_.seen) { PX_.x = e.clientX; PX_.y = e.clientY; } PX_.seen = true; }, { passive: true });
  function pill(dt, hv) {
    var on = finePointer && PX_.seen && hv > 0.4 && INTRO_T !== null && !document.body.classList.contains('intro');
    if (!on && !PX_.on) return;
    var a = Math.min(1, dt * 9), nx = PX_.x + (PX_.tx - PX_.x) * a, ny = PX_.y + (PX_.ty - PX_.y) * a;
    PX_.vx = PX_.vx * 0.8 + (nx - PX_.x) * 0.2; PX_.x = nx; PX_.y = ny;
    PILL.style.opacity = on ? Math.min(1, (hv - 0.4) * 3).toFixed(3) : 0;
    PILL.style.transform = 'translate3d(' + (PX_.x + 16).toFixed(1) + 'px,' + (PX_.y + 16).toFixed(1) + 'px,0) rotate(' + clamp(PX_.vx * 0.6, -8, 8).toFixed(2) + 'deg)';
    PX_.on = on;
  }
  var VIS = new Map();
  function vis(el, on) { if (VIS.get(el) !== on) { el.style.visibility = on ? 'visible' : 'hidden'; VIS.set(el, on); } }

  /* ================================================================ resize + loop */
  function resize() {
    VIEW.w = Math.max(1, innerWidth); VIEW.h = Math.max(1, innerHeight); VIEW.dpr = Math.min(window.devicePixelRatio || 1, phone() ? 2 : 1.75);
    renderer.setPixelRatio(VIEW.dpr); renderer.setSize(VIEW.w, VIEW.h, false);
    cam.aspect = VIEW.w / VIEW.h; cam.updateProjectionMatrix();
    CV.width = Math.round(VIEW.w * VIEW.dpr); CV.height = Math.round(VIEW.h * VIEW.dpr);
    worldLayout(); worldApply(WM.k || 0, WM.z || 1); layoutCaps(); dustSize();
    RS = stageRect(); KEYS = keys();
    if (SPARKS) { var u = VIEW.dpr * VIEW.h / 900; SPARKS.points.material.uniforms.uPx.value = u; TIP.material.uniforms.uPx.value = u; }
    if (CK) CK.last = -1;
  }
  var mouse = { x: 0, y: 0, sx: 0, sy: 0 };
  addEventListener('pointermove', function (e) { mouse.x = e.clientX / innerWidth - 0.5; mouse.y = e.clientY / innerHeight - 0.5; }, { passive: true });
  var tPrev = performance.now(), glShown = true, pSm = 0, pInit = false, zLast = 0, dkLast = -1;
  var CHALK = new THREE.Color(0.95, 0.937, 0.906), CARBON = new THREE.Color(0.067, 0.063, 0.055);
  function loop(now) {
    requestAnimationFrame(loop);
    if (lenis) lenis.raf(now);
    var dt = Math.min(0.05, (now - tPrev) / 1000), time = now / 1000; tPrev = now;
    mouse.sx += (mouse.x - mouse.sx) * Math.min(1, dt * 3.6); mouse.sy += (mouse.y - mouse.sy) * Math.min(1, dt * 3.6);
    var max = Math.max(1, document.documentElement.scrollHeight - innerHeight);
    var pRaw = clamp(window.scrollY / max, 0, 1);
    pSm = pInit ? pSm + (pRaw - pSm) * Math.min(1, dt * 8) : pRaw; pInit = true;
    if (Math.abs(pRaw - pSm) < 1e-5) pSm = pRaw;
    var p = pSm;

    // the lights: on for the photograph, down for the drawing and the making, up again for the finished piece
    var dk = seg(p, 0.28, 0.32) * (1 - seg(p, 0.86, 0.905));
    var z = 1 + 0.03 * sm(seg(p, 0.07, 0.14)) + 0.035 * sm(dk);
    var k = eio(seg(p, 0, 0.09)), hv = 1 - k;
    if (phone()) { mouse.sx = 0.22 * Math.sin(time * 0.35); mouse.sy = 0.12 * Math.sin(time * 0.27 + 1); }
    var mx = mouse.sx, my = mouse.sy;
    var wx = -mx * lerp(36, 10, k), wy = -my * lerp(20, 6, k);
    worldApply(k, z, { wx: wx, wy: wy, px: wx - mx * 52 * hv, py: wy - my * 24 * hv, ry: mx * 7 * hv, rx: -my * 4 * hv });
    pill(dt, hv);
    hero(p, k, time);
    dust(dt, time, hv);
    if (CK) CK.last = -1;                       // the camera drifts every frame, so the block is redrawn
    zLast = z;
    if (Math.abs(dk - dkLast) > 1e-4) {
      WDARK.style.opacity = dk.toFixed(3); document.body.classList.toggle('dk', dk > 0.5); dkLast = dk;
      if (U) U.uLineC.value.copy(CARBON).lerp(CHALK, dk);
    }
    RS = stageRect(); KEYS = keys();
    // the render becomes the photograph: a scan line wipes across, real behind it, render ahead of it
    var wipe = eio(seg(p, 0.9, 0.935)), wl = RS.cx - W / 2 * RS.s - 30, wr = RS.cx + W / 2 * RS.s + 30, WX = lerp(wl, wr, wipe);
    WSHADOW.style.opacity = p < 0.5 ? (1 - seg(p, 0.105, 0.128)).toFixed(3) : wipe > 0 ? sm(wipe).toFixed(3) : 0;
    if (p < 0.5) { WBUST.style.opacity = (1 - seg(p, 0.105, 0.128)).toFixed(3); WBUST.style.clipPath = 'none'; }
    else {
      WBUST.style.opacity = wipe > 0 ? 1 : 0;
      var sc = WM.s / WS.s, tx = WM.ox - WD.L * WM.s;
      var elX = (WX - tx) / sc - (WD.L + WD.crop[0]) * WS.s, elW = (WD.crop[2] - WD.crop[0]) * WS.s;
      WBUST.style.clipPath = wipe >= 1 ? 'none' : 'inset(0 ' + Math.max(0, elW - elX).toFixed(1) + 'px 0 0)';
    }
    canvas.style.clipPath = wipe > 0 && wipe < 1 ? 'inset(0 0 0 ' + WX.toFixed(1) + 'px)' : 'none';
    WIPE.style.opacity = wipe > 0 && wipe < 1 ? 1 : 0;
    if (wipe > 0 && wipe < 1) { WIPE.style.transform = 'translate3d(' + WX.toFixed(1) + 'px,' + (RS.cy - H / 2 * RS.s - 30).toFixed(1) + 'px,0)'; WIPE.style.height = (H * RS.s + 60).toFixed(1) + 'px'; }

    // layers that have nothing to show are taken out of the frame entirely (each full-screen layer costs a blend)
    vis(DUST, hv > 0.002); vis(WFRONT, p < 0.132 || p > 0.895); vis(CV, p > 0.1 && p < 0.36); vis(PILL, hv > 0.4);

    // the usual way: a block on the plinth, carved down
    drawCarve(seg(p, 0.165, 0.28), seg(p, 0.105, 0.128) * (1 - sm(seg(p, 0.315, 0.355))), dt);

    // our way: the drawing, the planes, the piece
    var glOn = ready && p > 0.3 && p < 0.936;
    if (glOn !== glShown) { canvas.style.visibility = glOn ? 'visible' : 'hidden'; glShown = glOn; }
    if (glOn) {
      apply(p, dt);
      var s = camAt(p), front = p < 0.375 || p > 0.895 ? 0 : 1;
      s.az += (Math.sin(time * 0.4) * 1.2 + mouse.sx * 4) * front; s.el += mouse.sy * -2 * front;
      frame(s);
      renderer.render(scene, cam);
    }
    overlay(p, time);
  }

  /* ================================================================ start */
  addEventListener('resize', resize);
  resize();
  // the page always opens, even if a part can't be built (the hero and the words never wait on the 3D)
  var go = function () { if (INTRO_T === null) INTRO_T = performance.now() / 1000 + 0.2; };
  Promise.all([loadImg(URLS.ao), loadImg(URLS.tie), loadImg(URLS.sil)]).then(function (ims) {
    try {
      buildCarve(ims[2]);
      drawCarve(0.6, 1, 0); drawCarve(0, 1, 0); drawCarve(0.95, 1, 0); drawCarve(0, 1, 0);
      CV.getContext('2d').getImageData(0, 0, 1, 1); CK.comp.getContext('2d').getImageData(0, 0, 1, 1);
      CK.last = -1; CK.chips.length = 0;
    } catch (e) { CK = null; if (window.console) console.warn('Our story: the carving is off', e); }
    try {
      buildStage(ims[0], ims[1]);
      apply(0.6, 0); frame(camAt(0.6)); renderer.render(scene, cam);
      apply(0.83, 0); frame(camAt(0.83)); renderer.render(scene, cam);
      renderer.clear(); apply(0, 0);
    } catch (e) { ready = false; if (window.console) console.warn('Our story: the 3D is off', e); }
  }).catch(function (e) { if (window.console) console.warn('Our story: images', e); }).then(function () {
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(go); else go();
  });
  setTimeout(go, 8000);
  requestAnimationFrame(loop);

  window.__story = {
    lenis: lenis,
    toP: function (p) {
      var max = document.documentElement.scrollHeight - innerHeight;
      if (lenis) lenis.scrollTo(p * max, { immediate: true, force: true }); else window.scrollTo(0, p * max);
      pInit = false;
    },
    st: ST
  };
})();
